import React from 'react'
import { Button, Typography } from 'antd'
import { Link } from 'react-router-dom'

/**
 * Lugnt besked när en sida inte kan visas — saknad behörighet, sida som inte finns.
 *
 * Ersätter antd:s `Result`, vars illustration är en stor tecknad figur som inte hör
 * hemma i resten av gränssnittet. Här räcker en dämpad ikon, en rubrik och en rad text.
 *
 * Alltid en väg vidare: en återvändsgränd utan knapp tvingar användaren att gissa sig
 * tillbaka via webbläsarens bakåtknapp.
 */

export type StatusMessageProps = {
  icon: React.ReactNode
  title: string
  /** Utelämnas när rubriken säger allt — en rad som upprepar den gör sidan sämre, inte tydligare. */
  body?: string
  /** Utelämnas bara om sidan renderas någonstans där startsidan inte är nåbar. */
  showStartLink?: boolean
}

const StatusMessage: React.FC<StatusMessageProps> = ({ icon, title, body, showStartLink = true }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 12,
        maxWidth: 420,
        margin: '0 auto',
        padding: '96px 24px 24px',
      }}
    >
      <span style={{ fontSize: 32, color: 'rgba(0, 0, 0, 0.25)', lineHeight: 1 }}>{icon}</span>

      <Typography.Title level={4} style={{ margin: 0 }}>
        {title}
      </Typography.Title>

      {body && (
        <Typography.Text type="secondary" style={{ fontSize: 14 }}>
          {body}
        </Typography.Text>
      )}

      {showStartLink && (
        <Link to="/app/start" style={{ marginTop: 12 }}>
          <Button type="primary">Till startsidan</Button>
        </Link>
      )}
    </div>
  )
}

export default StatusMessage
